export default __webpack_public_path__ + "static/media/ahsan.47985335.webp";